// ChangePositionModal.jsx - исправленная версия
import React, { useState, useEffect } from 'react';  // ← Добавьте эту строку
import './ChangePositionModal.css';

const ChangePositionModal = ({
  isOpen,
  onClose,
  employee,
  currentPositionId,
  newPositionId,
  positions,
  currentTrainings = [],
  onConfirm,
  isLoading = false
}) => {
  // ИЗМЕНЕНИЕ: Храним Set из course_id, а не training.id
  const [selectedCourseIds, setSelectedCourseIds] = useState(new Set());
  const [newPositionCourses, setNewPositionCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [error, setError] = useState(null);

  const currentPosition = positions.find(p => p.id === currentPositionId);
  const newPosition = positions.find(p => p.id === newPositionId);

  useEffect(() => {
    if (isOpen && newPositionId && employee) {
      fetchNewPositionCourses();
    }
  }, [isOpen, newPositionId, employee]);

  const fetchNewPositionCourses = async () => {
    setLoadingCourses(true);
    setError(null);
    try {
      const { matrixService } = await import('../../../services/matrixService');
      const matrix = await matrixService.getMatrix();
      
      const positionInMatrix = matrix.positions?.find(p => p.id === newPositionId);
      
      if (positionInMatrix && positionInMatrix.courses) {
        const courses = positionInMatrix.courses.map(c => ({
          id: c.courseId || c.id,
          name: c.name,
          isRequired: c.is_required !== false
        }));
        setNewPositionCourses(courses);
      } else {
        setNewPositionCourses([]);
      }
    } catch (err) {
      console.error('Ошибка загрузки курсов новой должности:', err);
      setError('Не удалось загрузить список обязательных курсов для новой должности');
      setNewPositionCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

  // ИЗМЕНЕНИЕ: Используем course_id для выбора
  useEffect(() => {
    if (isOpen && currentTrainings.length > 0) {
      // По умолчанию выбраны все курсы (по course_id)
      const allCourseIds = new Set(currentTrainings.map(t => t.course_id));
      setSelectedCourseIds(allCourseIds);
    } else if (isOpen) {
      setSelectedCourseIds(new Set());
    }
  }, [isOpen, currentTrainings]);

  // ИЗМЕНЕНИЕ: Выбор всех по course_id
  const handleSelectAll = () => {
    if (selectedCourseIds.size === currentTrainings.length) {
      setSelectedCourseIds(new Set());
    } else {
      const allCourseIds = new Set(currentTrainings.map(t => t.course_id));
      setSelectedCourseIds(allCourseIds);
    }
  };

  // ИЗМЕНЕНИЕ: Переключение по course_id
  const handleToggleTraining = (courseId) => {
    const newSelected = new Set(selectedCourseIds);
    if (newSelected.has(courseId)) {
      newSelected.delete(courseId);
    } else {
      newSelected.add(courseId);
    }
    setSelectedCourseIds(newSelected);
  };

  // ИЗМЕНЕНИЕ: Возвращаем course_id на бэкенд
  const handleConfirm = () => {
    const selectedCourseIdsArray = Array.from(selectedCourseIds);
    // Возвращаем массив course_id (ID курсов), а не training.id
    onConfirm(newPositionId, selectedCourseIdsArray);
  };

  const isRequiredForNewPosition = (trainingCourseId) => {
    return newPositionCourses.some(c => c.id === trainingCourseId);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content change-position-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Смена должности сотрудника</h3>
          <button className="modal-close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {/* Информация о сотруднике */}
          <div className="employee-info-block">
            <div className="info-row">
              <span className="info-label">Сотрудник:</span>
              <span className="info-value">{employee?.full_name || `${employee?.last_name} ${employee?.first_name}`}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Текущая должность:</span>
              <span className="info-value current-position">{currentPosition?.name || '—'}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Новая должность:</span>
              <span className="info-value new-position">{newPosition?.name || '—'}</span>
            </div>
          </div>

          <div className="position-change-divider">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14" />
              <path d="M12 5l7 7-7 7" />
            </svg>
          </div>

          <div className="trainings-selection">
            <div className="section-header">
              <h4>Текущие обучения сотрудника</h4>
              {currentTrainings.length > 0 && (
                <button className="select-all-btn" onClick={handleSelectAll}>
                  {selectedCourseIds.size === currentTrainings.length ? 'Отменить все' : 'Выбрать все'}
                </button>
              )}
            </div>

            {loadingCourses && (
              <div className="loading-courses">
                <div className="spinner-small"></div>
                <span>Загрузка обязательных курсов...</span>
              </div>
            )}

            {error && (
              <div className="error-message-small">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {error}
              </div>
            )}

            {currentTrainings.length === 0 ? (
              <div className="empty-trainings-message">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                </svg>
                <span>У сотрудника нет назначенных обучений</span>
              </div>
            ) : (
              <div className="trainings-list-container">
                <table className="trainings-selection-table">
                  <thead>
                    <tr>
                      <th className="checkbox-col"></th>
                      <th>Название курса</th>
                      <th>Статус</th>
                      <th>Дата истечения</th>
                      <th>Для новой должности</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTrainings.map(training => {
                      const isRequired = isRequiredForNewPosition(training.course_id);
                      // ИСПРАВЛЕНИЕ: Используем course_id для проверки выбора
                      const isSelected = selectedCourseIds.has(training.course_id);
                      
                      return (
                        <tr key={training.id} className={isRequired && !isSelected ? 'warning-row' : ''}>
                          <td className="checkbox-col">
                            <label className="checkbox-label">
                              {/* ИСПРАВЛЕНИЕ: Передаем course_id */}
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleToggleTraining(training.course_id)}
                              />
                              <span className="checkbox-custom"></span>
                            </label>
                          </td>
                          <td className="course-name" title={training.name}>
                            {training.name}
                          </td>
                          <td>
                            <span className={`status-badge-small ${training.status || 
                              (training.completedDate ? 'completed' :
                               training.isRequired ? 'required' :
                               training.isPerpetual ? 'perpetual' :
                               training.daysLeft <= 0 ? 'expired' :
                               training.daysLeft <= 30 ? 'warning' : 'active')
                            }`}>
                              {training.completedDate ? 'Пройдено' : 
                               training.isRequired ? 'Требуется' :
                               training.isPerpetual ? 'Бессрочно' :
                               training.daysLeft <= 0 ? 'Просрочено' :
                               training.daysLeft <= 30 ? 'Истекает' : 'Активно'}
                            </span>
                          </td>
                          <td className="expires-date">
                            {training.isRequired ? '—' :
                             training.isPerpetual ? 'Бессрочно' :
                             training.expiresDate ? new Date(training.expiresDate).toLocaleDateString('ru-RU') : '—'}
                          </td>
                          <td>
                            {isRequired ? (
                              <span className="required-badge">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                Обязателен
                              </span>
                            ) : (
                              <span className="optional-badge">Не обязателен</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            <div className="info-block">
              <div className="info-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              </div>
              <div className="info-content">
                <strong>Важная информация:</strong>
                <ul>
                  <li>Обучения, отмеченные как <span className="required-badge-inline">Обязательные</span>, необходимы для новой должности.</li>
                  <li>Если вы не выберете обязательное обучение, оно будет автоматически назначено сотруднику.</li>
                  <li>Необязательные обучения можно оставить или удалить по вашему усмотрению.</li>
                  <li>Пройденные обучения рекомендуется сохранять для сохранения истории.</li>
                  <li>При смене должности сотрудник получит все обязательные курсы новой должности.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={isLoading}>
            Отмена
          </button>
          <button 
            className="btn-primary" 
            onClick={handleConfirm} 
            disabled={isLoading}
          >
            {isLoading ? 'Сохранение...' : 'Подтвердить смену должности'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePositionModal;